import { SvgIcon, SvgIconProps } from '@mui/material';

export const TagIcon = (props?: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <circle cx="10" cy="10" r="10" fill="inherit" />
    <path d="M8.26558 11.9657L5.98099 9.5968L5 10.614L8.26558 14L15 7.01717L14.019 6L8.26558 11.9657Z" />
  </SvgIcon>
);
